module.exports = __webpack_public_path__ + "static/probook-logo-hover-2a6af26838c2461c11d5fc4ed271a7f1.png";